import axios from 'axios'
//使用工具qs来处理参数
import qs from 'qs'
import Vue from 'vue'
//加密
import CryptoJS from "crypto-js";
import {
  Toast
} from 'vant';

Vue.use(Toast);



//开发环境url
// 测试"/test"
// const baseURL = "/test";
//正式 "/api"
const baseURL = "/api";
//判断是开发环境还是 测试环境




axios.defaults.baseURL = baseURL
axios.defaults.timeout = 15000; //响应时间
// axios.defaults.headers.get['Content-Type'] = 'Accept: */*';


//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  //在发送请求之前做某件事
  if (config.method === 'post') {
    config.data = config.data;
    config.data.param = localStorage.getItem("orderNo");
  }else{
    config.params.param = localStorage.getItem("orderNo");
  }
  return config;
}, (error) => {
  console.log('params error')
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  //对响应数据做些事
  if (res.data.code!=200) {
    Toast.fail(res.data.message);
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  console.log('neter error')
  return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, )
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
//返回一个Promise(发送get请求)
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
       params: param
    })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default {
  fetchPost,
  fetchGet,
}



// WEBPACK FOOTER //
// ./src/request/axios.js